import React, { useEffect } from 'react';
import { FaSearchengin, FaShopify } from 'react-icons/fa';


// Navbar Component
export default function Navbar({initAOS}){
  initAOS();
  
  return (
    <nav className="bg-black/10 backdrop-blur-md shadow-sm py-4 px-6 lg:px-12 fixed top-0 w-full z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-2">
            {/* <img src={logo} width={100} alt="" /> */}
            <FaSearchengin className="text-rich_black-500 text-4xl" />
            <span className="text-4xl py-1 font-bold bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 bg-clip-text text-transparent">
                Fixify<span className="text-sm">SEO</span>
            </span>
        </div>
        
        <div className="hidden md:flex space-x-8">
          <a href="#features" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Features</a>
          <a href="#pricing" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Pricing</a>
          <a href="#testimonials" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Success Stories</a>
          <a href="#contact" className="text-gray-600 hover:text-teal-500 hover:underline transition-all">Contact</a>
        </div>
        
        <div className="flex items-center space-x-4">
          <a href="/login" className="text-gray-600 hover:text-teal-500 transition">Sign In</a>
          <a 
            href="/register" 
            className="bg-gradient-to-r from-fixify-darkBg to-dark_cyan-500 text-vanilla-500 px-4 py-2 rounded-md hover:opacity-90 transition shadow-md"
          >
            Get Started
          </a>
        </div>
      </div>
    </nav>
  );
};